/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

export var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export var AlertTypeIdsEnum = {
    UnitOffline: "35",
    Provisioning: "116",
    LooseBattery: "107",
    LowSubgRSSI: "94",
    LowWifiSignal: "118",
    MissingParameterinFurnaceAlgorithm :"57"
};

export var InstallFailureTypesEnum = {
    CtWrongWire: 1,
    CtNotPluggedIn: 2,
    NoData: 3,
    BadData: 4,
    Other: 5,
    LooseBattery: 6
};

export var ComponentGroupIdsEnum = {
    Inducer: 1,
    Ignition_HeatSource: 2,
    GasValve: 3,
    Blower: 4,
    Compressor: 5,
    Condenser: 6,
    Evaporator: 7,
    ExpansionValve: 8,
    ReversingValve: 9
};

export var SupportLevelIdsEnum = {
    Fully: 1,
    Partially: 2,
    NeedsMoreInfo: 3
};

export var InstallFailureTypes = [
    {
        id: 1,
        name: 'CT on wrong wire'
    },
    {
        id: 2,
        name: 'CT not plugged in'
    },
    {
        id: 3,
        name: 'No data'
    },
    {
        id: 4,
        name: 'Bad data'
    },
    {
        id: 5,
        name: 'Other'
    }
];

export var TagIdsEnum = {
    AlertPartnerViaEmail: "78",
    JobCreated: "91",
    NewAlert: "94",
    QuestionAsked: "98",
    QuestionAnswered: "99",
    NewComment: "172"
};

export var ConversationTypeEnum = {
    AlertComment: 3,
    OpportunityComment: 2,
    AssetComment: 5
};

export var TriageStatusTypes = {
    Escalated: {
        id: 1,
        name: 'Escalated'
    },
    FalsePositive: {
        id: 2,
        name: 'False Positive'
    },
    Other: {
        id: 3,
        name: 'Other'
    },
    Untriaged: {
        id: 4,
        name: 'Untriaged'
    },
    Missed: {
        id: 5,
        name: 'Missed'
    },
    ManualRetrain: {
        id: 6,
        name: 'Manual Retrain'
    }
}

export var TriageActions = {
    ESCALATE: "ESCALATE",
    MISSED: "MISSED",
    FALSE_POSITIVE: "FALSEPOSITIVE",
    CLOSE_INTERNAL: "CLOSEINTERNAL",
    ADD_TAGS: "ADDTAGS",
    CHANGE_ALERT_TYPE: "CHANGEALERTTYPE",
    MANUAL_RETRAIN: "MANUALRETRAIN"
}

export var RetrainAlertTypes = {
    BLOWER_CAP_FAILURE: "Blower Cap Failure"
}

export var AlertIndicatorSort = {
    None: 0,
    NewAlerts: 1,
    QuestionAnswered: 2,
    QuestionAsked: 3,
    NewComments: 4
};

export var ThermostatPocData = {
    apiKey: "j84mnRf4qEDu3ieMBZYCzwGpJQk2VtCq",
    userRefID: "1706367",
    locationId: "1499564",
    deviceId: "LCC-B82CA049D8DA",
    updateSP: {
        mode: "Heat",
        heatSetpoint: 90,
        coolSetpoint: 60,
        thermostatSetpointStatus: "TemporaryHold",
        autoChangeoverActive: true,
        nextPeriodTime: "18:00:00",
        heatCoolMode: "Heat"
    }
}

export var jsAsset = {
    assetId: 0,
    description: "",
    mac: "",
    make: "",
    mfgDate: "",
    model: "",
    name: "",
    nickname: "",
    parentAssetId: 0,
    path: [],
    properties: [],
    sensorFw: "",
    sensorMac: "",
    serialNumber: "",
    status: 0,
    type: "",
    classes: [],
    unappliedClasses: [],
    applyList: [],
    removeList: [],
    compressorRatedLoadAmps: "",
    compressorLockedRotorAmps: "",
    fanFullLoadAmps: "",
    fanLockedRotorAmps: "",
    furnaceMac: "",
    furnaceId: "",
    furnaceCurrentPropId: "",
    furnaceTempPropId: "",
    acCurrentPropId: "",
    acTempPropId: "",
    offHigh: "",
    hasAnalytics: false
};

export const assetHierarchy={
    children:[],
    id:-1,
    name:"",
    type:-1,
    nickname:"",
};
export var jsHouse = {
    orgId: "",
    parentId: "",
    assetId: 0,
    nickname: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    latitude: "",
    longitude: "",
    location: "",
    locationId: "",
    proLocationId: ""
};

export var jsDevice = {
    deviceId: "",
    parentId: "",
    nickname: "",
    mac: "",
    subMac: "",
    deviceType: "",
    status: "",
    portalStatus: "",
    orgName: "",
    sensor1: "",
    sensor2: "",
    mapsTo1: "",
    mapsTo2: "",
    createdOn: "",
    lastUpdated: "",
    gatewayFw: "",
    wifiRSSI: 0,
    wifiRSSI_dBm: 0,
    wifiRSSI_Scale: 0,
    wifiRSSI_Timestamp: "",
    dropouts: "",
    subgRSSI: 0,
    subgRSSI_dBm: 0,
    subgRSSI_Scale: 0,
    subgRSSI_Timestamp: "",
    subgChan: "",
    sensorMAC: "",
    sensorFw: "",
    configuration: "",
    batteryVoltage: "",
    batteryVoltage_Timestamp: "",
    subBatteryVoltage: "",
    deviceTemperature: "",
    deviceTemperature_Timestamp: "",
    current: "",
    current_Timestamp: ""

};

export var alertCustomer = {
    parentOrganizationId: null,
    organizationId: null,
    userId: null,
    houseAssetId: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    name: null,
    address: "",
    city: "",
    state: "",
    zip: ""
};

export var jsPoint = {
    orgId: "",
    parentId: "",
    houseAssetId: "",
    color: "",
    name: "",
    address: "",
    phone: "",
    email: "",
    latitude: null,
    longitude: null,
    house: null,
    openActiveAlerts: 0,
    openInactiveAlerts: 0
};

export var jsOpportunity = {
    caseId: "",
    number: "",
    type: "",
    priority: 0,
    status: "",
    sourceId: 0,
    subject: "",
    impact: undefined,
    comment: "",
    assignedToId: "",
    assignedToName: "",
    createdOnStr: "",
    assignedOnStr: "",
    closedOnStr: "",
    scheduledForStr: "",
    scheduledTimeStr: "",
    scheduledForTimeStr: "",
    closedTimeStr: "",
    details: [],
    isFalsePositive: null,
    alertId: "",
    assetId: "",
    assetType: "",
    proCustomerId: "",
    proCustomerName: ""
};

export var jsUpdateOpportunity = {
    caseId: 0,
    subject: "",
    //sourceId: "",
    priority: 0,
    comment: ""
}

export var jsAddAlert = {
    alertTypeId: 0,
    comment: null,
    message: null,
    priority: 0,
    sourceId: 0,
    startTime: null,
    endTime: null,
    topicType: 1 
};

export var jsCustomAlert = {
    partnerId: 0,
    alertTypeId: 0,
    name: "",
    description: "",
    priority: 1
};

export var jsCustomAlertMessaging = {
    partnerId: 0,
    alertTypeId: 0,
    possibleCauses: "",
    techAction: "",
    homeownerAction: "",
    risk: "",
    severity: ""
};

export var jsComponent = {
    caseId: 0,
    componentId: -1,
    oem: "",
    other: "None"
}

export var jsAppointment = {
    caseId: 0,
    appointmentDate: null,
    verificationId: 0,
    useCaseId: 0,
    timeToRepair: 0,
    jobValue: "",
    notes: "",
    closed: null,
    componentReplaced: []
}

export var jsConversation = {
    conversationId: null,
    conversationtype: 3,
    genesisId: "",
    message: "",
    private: false
}

export var jsAlert = {
    alertId: "",
    name: "",
    priority: 0,
    message: "",
    recommendation: "",
    comments: "",
    startTime: "",
    startTimeFormatted: "",
    duration: "",
    endTime: "",
    assetClassIds: [],
    drill: "",
    isFalsePositive: null,
    isVerified: null,
    isOpen: null,
    isClosed: null,
    isMuted: null,
    closedOn: "",
    assetId: "",
    organization: "",
    organizationName: "",
    isActive: null,
    isAssetActive: null,
    typeId: "",
    proCustomerId: "",
    proCustomerName: ""
};

export var jsGraph = {
    deviceId: "",
    startTimeStr: "",
    endTimeStr: "",
    startTimeDailyStr: "",
    endTimeDailyStr: "",
    maxPointsInRunTime: 0,
    maxPointsInDailyTime: 0,
    dataArray1: [],
    dataArray2: [],
    currentData1: [],
    currentData2: [],
    currentArray1: [],
    currentArray2: [],
    yDataMin1: 0,
    yDataMax1: 0,
    yDataMin2: 0,
    yDataMax2: 0,
    alertTimeStr: "",
    alertStartTime: null,
    alertEndTime: null,
    dailyStartTime: null,
    dailyEndTime: null,
    runGraphData: null,
    dailyGraphData: null
};

export var jsACGraph = {
    deviceIdAC: "",
    deviceIdFurnace: "",
    furnaceMAC: "",
    startTimeStr: "",
    endTimeStr: "",
    startTimeDailyStr: "",
    endTimeDailyStr: "",
    maxPointsInRunTime: 0,
    maxPointsInDailyTime: 0,
    dataArray1: [],
    dataArray2: [],
    currentData1: [],
    currentData2: [],
    currentArray1: [],
    currentArray2: [],
    yDataMin1: 0,
    yDataMax1: 0,
    yDataMin2: 0,
    yDataMax2: 0,
    tempMax: 0,
    rla: 0,
    lra: 0,
    alertTimeStr: "",
    alertStartTime: null,
    alertEndTime: null,
    dailyStartTime: null,
    dailyEndTime: null,
    runGraphData: null,
    dailyGraphData: null
};

export var jsAssetTimelineGraph = {
    deviceId: "",
    startTimeStr: "",
    endTimeStr: "",
    maxPoints: 0,
    dataArray: [],
    currentData: [],
    currentArray: [],
    yDataMin1: 0,
    yDataMax1: 0,
    timeStr: "",
    startTime: null,
    endTime: null,
    dailyGraphData: null
}

export var jsACAssetTimelineGraph = {
    deviceIdAC: "",
    deviceIdFurnace: "",
    peerType: "Furnace",
    startTimeStr: "",
    endTimeStr: "",
    maxPoints: 0,
    dataArray: [],
    currentData: [],
    currentArray: [],
    yDataMin1: 0,
    yDataMax1: 0,
    tempMax: 0,
    rla: 0,
    lra: 0,
    timeStr: "",
    startTime: null,
    endTime: null,
    dailyGraphData: null
}

export var jsAssetsGraphData = {
    deviceId: "",
    startTime: null,
    startTimeStr: "",
    endTime: null,
    endTimeStr: "",
    timeStr: "",
    offHigh: 0.3,
    maxPointsInRunTime: 0,
    properties: [],
    unsetProperties: [],
    currentData: [],
    currentArray: [],
    dataArray: [],
    equipmentRuns: [],
    runNamesList: [],
    timeSeriesDataSources: [],
    graphData: []
};

export var jsACAssetsGraphData = {
    deviceIdAC: "",
    deviceIdFurnace: "",
    peerType: "Furnace",
    furnaceMAC: "",
    startTime: null,
    startTimeStr: "",
    endTime: null,
    endTimeStr: "",
    timeStr: "",
    offHigh: 0.3,
    rla: 0.0,
    lra: 0.0,
    maxPointsInRunTime: 0,
    propertiesAC: [],
    unsetPropertiesAC: [],
    propertiesFurnace: [],
    unsetPropertiesFurnace: [],
    currentData: [],
    currentArray: [],
    dataArray: [],
    equipmentRuns: [],
    runNamesList: [],
    timeSeriesDataSources: []
};

export var jsGraphData = {
    count: null,
    minX: 0,
    maxX: 0,
    minY: 0,
    maxY: 0,
    dataArray: [],
    dataSource: [
        {
            timeStamp: "",
            value: "",
            index: -1
        }],
    propertiesForAnalytics: {},
    graphAnnotations: [],
    graphArrowAnnotations: [],
    timeString: ""
};

export var jsACGraphData = {
    count: null,
    minX: 0,
    maxX: 0,
    minY: 0,
    maxY: 0,
    dataArray: [],
    dataSource: [
        {
            timeStamp: "",
            value: "",
            furnaceValue: "",
            rla: "",
            lra: "",
            indoorTemp: "",
            outdoorTemp: "",
            index: -1
        }],
    propertiesForAnalytics: {},
    graphAnnotations: [],
    graphArrowAnnotations: [],
    timeString: ""
};

export var jsSource = {
    count: 0,
    minX: 0,
    maxX: 0,
    minY: 0,
    maxY: 0,
    dataArray: [],
    dataSource: [
        {
            timeStamp: "",
            value: "",
            index: -1
        }],
    propertiesForAnalytics: {},
    graphAnnotations: [],
    graphArrowAnnotations: [],
    timeString: ""
};

export var jsACSource = {
    count: 0,
    minX: 0,
    maxX: 0,
    minY: 0,
    maxY: 0,
    dataArray: [],
    dataSource: [
        {
            timeStamp: "",
            value: "",
            furnaceValue: "",
            rla: "",
            lra: "",
            indoorTemp: "",
            outdoorTemp: "",
            index: -1
        }],
    propertiesForAnalytics: {},
    graphAnnotations: [],
    graphArrowAnnotations: [],
    timeString: ""
};

export var jsDetails = {
    caseId: 0,
    number: "",
    type: "",
    priority: 0,
    status: "",
    impact: "",
    impactEstimate: "",
    comment: "",
    assignedToId: "",
    scheduledFor: "",
    isClosed: false,
    scheduledOn: "",
    closedOn: "",
    isFalsePositive: null,
    organizationId: 0,
    houseAssetId: "",
    customerOrgId: "",
    customerFirstName: "",
    customeLastName: ""
};

export var jsTechnician = {
    userId: "",
    firstName: null,
    lastName: null,
    email: null,
    isActive: null,
    lastLogin: null,
    roleList: null,
    roleListId: [],
    roleListIdStr: null
};

export var jsCustomer = {
    parentOrganizationId: null,
    organizationId: null,
    parentAccountId: null,
    accountId: null,
    userId: null,
    houseAssetId: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    name: null,
    address: "",
    city: "",
    state: "",
    zip: ""
};

export var jsPartner = {
    organizationId: null,
    parentOrganizationId: null,
    name: "",
    company: "",
    description: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    phone: "",
    logo: null,
    logoId: null,
    icon: null,
    iconId: null,
    logoData: null,
    iconData: null,
    notificationEmailAddresses: null,
    users: [
        {
            firstName: null,
            lastName: null,
            email: null,
            isActive: null,
            lastLogin: null,
            roleList: null
        }
    ],
    isBillable: "",
    contractType: "",
    firstBillingDate: "",
    complementaryUnits: "0",
    escalationType :"",
    notificationType : "",
    applicationNotificationTime :"0",
    alertsToReview:false,
    proPartnerAccountId: ""
};

export var jsHomeowner = {
    firstName: "",
    lastName: "",
    company: "",
    description: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    locationName: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    parentOrganizationId: null,
    organizationId: null,
    userId: null,
    houseAssetId: null
};

export var jsNewHomeowner = {
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    phoneNumber: "",
    homeNickname: "",
    locationName: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "USA",
    parentOrganizationId: -1,
    company: "",
    billingPlanId: -1
};

export var jsAccount = {
    parentAccountId: null,
    accountId: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    description: null,
    company: null,
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    familyMembers: [
        {
            name: null,
            email: null,
            userId: null
        }
    ],
    inviteEmail: null,
    customerRecordId :"",
    proCustomerId: null,
    proPartnerId: null,
    attributes: [{
        attributeId: null,
        name: null,
        description: null,
        dataTypeId: null,
        dataType: null,
        value: null,
        units: null
    }]
};

export var jsCurrentAccount = {
    firstName: null,
    lastName: null,
    email: null,
    picture: null
};

export var jsAssetDeletionLog = {
    userEmail: "",
    assetList: [
        {
            assetId: null,
            assetName: ""
        }
    ]
};

export var jsAvgCurrents = {
    avgMainCurrent: [],
    avgInducerCurrent: [],
    avgBlowerCurrent: []
};

export var jsScheduleDetails = {
    scheduledDate: "",
    technician: "",
    jobvalue: "",
    jobNotes: "",
    jobStatus: "",
    lwJobID : "",
    stID :"",
    invoiceTotal :"0"
};

export var roles = {
    admin: 'ADMIN',
    customerSupport: 'CUSTOMER SUPPORT',
    operations: 'OPERATIONS',
    partnerAdmin: 'PARTNER ADMIN',
    supportAdmin: 'SUPPORT ADMIN',
    qa: 'QA',
    scheduler: 'SCHEDULER',
    superAdmin: 'SUPER ADMIN',
    technician: 'TECHNICIAN'
}

export var notificationTime  = {
    every6hours: '4x a Day (Every 6 hours)',
    daily: 'Daily',
    weekly: 'Weekly'
}

export var trainingTooltips ={
    overview: 'Hover over numbers for a detailed explanation',
    new: 'Assets that have not gone through provisioning checks',
    awaitingData: 'Assets ready to go through the training',
    training: 'Assets with confirmed runs ready to be trained',
    trained: 'Assets that have been trained but are not published and monitored',
    operational: 'Assets that are running analytics',
    reprovision: 'Assets that were flagged with installation issues',
    retrain: 'Assets that need to be retrained'
}

export var AssetStateStrings = ['new', 'awaitingData', 'training', 'trained', 'operational', 'reprovision', 'retrain'];

export var AssetStateOptions = [
    {
        value: 'All',
        label: 'All'
    },
    {
        value: 'New',
        label: 'New'
    },
    {
        value: 'AwaitingData',
        label: 'Awaiting Data'
    },
    {
        value: 'Training',
        label: 'Training'
    },
    {
        value: "Trained",
        label: "Trained"
    },
    {
        value: 'Operational',
        label: 'Operational'
    },
    {
        value: 'Reprovision',
        label: 'Reprovision'
    },
    {
        value: 'Retrain',
        label: 'Retrain'
    }
];

export var thermostatDataVariables = {
    TstatIndoorTemp: {
        name: "TSTAT Indoor Temp",
        dataName: "thermo_indoorTemp",
        color: "#a2e099"
    },
    TstatOutdoorTemp: {
        name: "TSATAT Outdoor Temp",
        dataName: "thermo_outdoorTemp",
        color: "#3d6824"
    },
    IndoorTemp: {
        name: "Indoor Temp",
        dataName: "thermo_indoorTemp",
        color: "#a2e099"
    },
    OutdoorTemp: {
        name: "Outdoor Temp",
        dataName: "thermo_outdoorTemp",
        color: "#3d6824"
    },
    IndoorHum: {
        name: "Indoor Humidity",
        dataName: "thermo_indoorHum",
        color: "#e0b499"
    },
    OutdoorHum: {
        name: "Outdoor Humidity",
        dataName: "thermo_outdoorHum",
        color: "#9c6e3a"
    },
    CoolSetpoint: {
        name: "Cool Setpoint",
        dataName: "thermo_coolSp",
        color: "#d399e0"
    },
    HeatSetpoint: {
        name: "Heat Setpoint",
        dataName: "thermo_heatSp",
        color: "#7fc6f5"
    }
}


export function createOnboardingGraphSettings (assetType) {
    return {
        trained: {
            name: `Trained ${assetType}s`,
            color: '#176a95'
        },
        failed: {
            name: `${assetType}s that failed training`,
            color: 'red'
        },
        notEnoughData: {
            name: `${assetType}s with not enough data`,
            color: 'orange'
        }
    };
}

export function createOnboardingSummaryGraphSettings () {
    return {
        furnace: {
            trained: {
                name: `Trained Furnaces`,
                color: '#df1919'
            },
            failed: {
                name: `Furnaces that failed training`,
                color: '#800303'
            },
            notEnoughData: {
                name: `Furnaces with not enough data`,
                color: '#ea6676'
            }
        },
        air_conditioner: {
            trained: {
                name: `Trained Air Conditioners`,
                color: '#3487b3'
            },
            failed: {
                name: `Air Conditioners that failed training`,
                color: '#035680'
            },
            notEnoughData: {
                name: `Air Conditioners with not enough data`,
                color: '#62bded'
            }
        },
        air_handler: {
            trained: {
                name: `Trained Air Handlers`,
                color: '#8524ec'
            },
            failed: {
                name: `Air Handlers that failed training`,
                color: '#40089f'
            },
            notEnoughData: {
                name: `Air Handlers with not enough data`,
                color: '#ac84d6'
            }
        },
        heat_pump: {
            trained: {
                name: `Trained Heat Pumps`,
                color: '#24d50a'
            },
            failed: {
                name: `Heat Pumps that failed training`,
                color: '#347c17'
            },
            notEnoughData: {
                name: `Heat Pumps with not enough data`,
                color: '#96f477'
            }
        }
    };
}

export var allRoleList = [roles.superAdmin, roles.admin, roles.customerSupport, roles.operations, roles.partnerAdmin, roles.supportAdmin, roles.technician, roles.scheduler]

export var alertSearchStartDate = "2021-04-01";



export var jsSession = {
    id: 0,
    userId: 0,
    dailyId: 0,
    startDateTimeStr: "",
    startDateTime: null,
    endDateTimeStr: "",
    endDateTime: null,
    triagedAlerts: []
};

export var furnacePropertyTypes = [
        {
            "name": "id",
            "type": "STATIC"
        },
        {
            "name": "ignitionLow",
            "type": "FLOAT"
        },
        {
            "name": "ignitionHigh",
            "type": "FLOAT"
        },
        {
            "name": "afueRating",
            "type": "STATIC"
        },
        {
            "name": "supportsIgnitionFromBlowerOn",
            "type": "BOOL"
        },
        {
            "name": "supportsPressureSwitchCalibration",
            "type": "BOOL"
        },
        {
            "name": "fanOnlyMode",
            "type": "INTEGER"
        },
        {
            "name": "fanOnlyHigh",
            "type": "FLOAT"
        },
        {
            "name": "fanOnlyLow",
            "type": "FLOAT"
        },
        {
            "name": "fanOnlyOnHigh",
            "type": "FLOAT"
        },
        {
            "name": "fanOnlyOnLow",
            "type": "FLOAT"
        },
        {
            "name": "offHigh",
            "type": "FLOAT"
        },
        {
            "name": "delayHigh",
            "type": "FLOAT"
        },
        {
            "name": "delayLow",
            "type": "FLOAT"
        },
        {
            "name": "blowerOnHigh",
            "type": "FLOAT"
        },
        {
            "name": "blowerOnLow",
            "type": "FLOAT"
        },
        {
            "name": "blowerOffDelay",
            "type": "INTEGER"
        },
        {
            "name": "shutdownHigh",
            "type": "FLOAT"
        },
        {
            "name": "shutdownLow",
            "type": "FLOAT"
        },
        {
            "name": "blowerDelayDuration",
            "type": "INTEGER"
        },
        {
            "name": "postPurgePeriod",
            "type": "INTEGER"
        },
        {
            "name": "inductionHigh",
            "type": "FLOAT"
        },
        {
            "name": "inductionLow",
            "type": "FLOAT"
        },
        {
            "name": "inductionOnAmps",
            "type": "FLOAT"
        },
        {
            "name": "inductionOffAmpsMin",
            "type": "FLOAT"
        },
        {
            "name": "inductionOffAmpsMax",
            "type": "FLOAT"
        },
        {
            "name": "instantInduction",
            "type": "BOOL"
        },
        {
            "name": "gasValveOffLow",
            "type": "FLOAT"
        },
        {
            "name": "gasValveOffHigh",
            "type": "FLOAT"
        },
        {
            "name": "prepurgeHigh",
            "type": "FLOAT"
        },
        {
            "name": "prepurgeLow",
            "type": "FLOAT"
        },
        {
            "name": "ignitionDuration",
            "type": "INTEGER"
        },
        {
            "name": "ignitionRetries",
            "type": "INTEGER"
        },
        {
            "name": "igniterOnAmps",
            "type": "FLOAT"
        },
        {
            "name": "blowerTypeId",
            "type": "STATIC"
        },
        {
            "name": "blowerTypeName",
            "type": "SELECT"
        },
        {
            "name": "blowerStageId",
            "type": "STATIC"
        },
        {
            "name": "blowerStageName",
            "type": "SELECT"
        },
        {
            "name": "igniterTypeId",
            "type": "STATIC"
        },
        {
            "name": "igniterTypeName",
            "type": "SELECT"
        }
    ];

export var multiCTFurnacePropertyTypes = [
    {
        "name": "id",
        "type": "STATIC"
    },
    {
        "name": "blowerOnDelay",
        "type": "INTEGER"
    },
    {
        "name": "blowerDelayDuration",
        "type": "INTEGER"
    },
    {
        "name": "blowerOffDelay",
        "type": "INTEGER"
    },
    {
        "name": "blowerMedian",
        "type": "FLOAT"
    },
    {
        "name": "blowerOnAmps",
        "type": "FLOAT"
    },
    {
        "name": "fanOnlyOnLow",
        "type": "FLOAT"
    },
    {
        "name": "fanOnlyOnHigh",
        "type": "FLOAT"
    },
    {
        "name": "gasValveOff",
        "type": "FLOAT"
    },
    {
        "name": "gasValveOnAmps",
        "type": "FLOAT"
    },
    {
        "name": "inductionOnAmps",
        "type": "FLOAT"
    },
    {
        "name": "inducerMedian",
        "type": "FLOAT"
    },
    {
        "name": "ignitionDuration",
        "type": "INTEGER"
    },
    {
        "name": "ignitionLow",
        "type": "FLOAT"
    },
    {
        "name": "ignitionRetries",
        "type": "INTEGER"
    },
    {
        "name": "igniterOnAmps",
        "type": "FLOAT"
    },
    {
        "name": "offHigh",
        "type": "FLOAT"
    },
    {
        "name": "offHighBlower",
        "type": "FLOAT"
    },
    {
        "name": "offHighInducer",
        "type": "FLOAT"
    },
    {
        "name": "postPurgePeriod",
        "type": "INTEGER"
    },
    {
        "name": "prepurgeDuration",
        "type": "INTEGER"
    },
    {
        "name": "blowerTypeId",
        "type": "STATIC"
    },
    {
        "name": "blowerTypeName",
        "type": "SELECT"
    },
    {
        "name": "blowerStageId",
        "type": "STATIC"
    },
    {
        "name": "blowerStageName",
        "type": "SELECT"
    },
    {
        "name": "igniterTypeId",
        "type": "STATIC"
    },
    {
        "name": "igniterTypeName",
        "type": "SELECT"
    }
];

export var jsAnalyzeIgnition = {
    delayHigh: "",
    delayLow: "",
    ignitionLow: "",
    ignitionHigh: "",
    igniterONAmps: ""
};
export var jsAnalyzeShutdown = {
    gasValveOffHigh: "",
    gasValveOffLow: "",
    inductionOffAmps: "",
    shutdownHigh: "",
    shutdownLow: ""
};

export var jsdeviceModels = {
    lpx: "LPX",
    diagnostiq: "DiagnostIQ",
    denali: "Denali"
};

export var jsdeviceClass = {
    lpxclass: "LifePulseX",
    diagnostiqclass: "LifePulseX",
    denaliClass: "LifePulseX"
};

export var jsdevicetags = {
    lpxtag: "LifePulseT10",
    diagnostiqtag: "LifePulseT10",
    denalitag: "Denali"
};

//doesnt include General and All
export var AssetTypeOptions = [
    {
        value: 1,
        label: "Furnace"
    },
    {
        value: 2,
        label: "AirConditioner"
    },
    {
        value: 3,
        label: "HeatPump"
    },
    {
        value: 4,
        label: "AirHandler"
    },
    {
        value: 0,
        label: "Other"
    }
];
export var AssetTypeDict = [
    {
        name: "Other",
        id: 0
    },
    {
        name: "Furnace",
        id: 1
    },
    {
        name: "AirConditioner",
        id: 2
    },
    {
        name: "HeatPump",
        id: 3
    },
    {
        name: "AirHandler",
        id: 4
    },
    {
        name: "General",
        id: 5, //1341 // QA
    },
    {
        name: "All",
        id: 6 //1342 // QA
    }
]

export var daysByMonthOptions = [
    { label: "30 days", value: 1 },
    { label: "60 days", value: 2 },
    { label: "90 days", value: 3 },
    { label: "120 days", value: 4 },
    { label: "150 days", value: 5 },
    { label: "180 days", value: 6 },
    { label: "210 days", value: 7 },
    { label: "240 days", value: 8 },
    { label: "270 days", value: 9 },
    { label: "300 days", value: 10 },
    { label: "330 days", value: 11 },
    { label: "360 days (1 year)", value: 12 },
    { label: "390 days", value: 13 },
    { label: "420 days", value: 14 },
    { label: "450 days", value: 15 },
    { label: "480 days", value: 16 },
    { label: "510 days", value: 17 },
    { label: "540 days", value: 18 },
    { label: "570 days", value: 19 },
    { label: "600 days", value: 20 },
    { label: "630 days", value: 21 },
    { label: "660 days", value: 22 },
    { label: "690 days", value: 23 },
    { label: "720 days (2 years)", value: 24 }
];

export var assetType = {
    Other: 0,
    Furnace: 1,
    AirConditioner: 2,
    HeatPump: 3,
    AirHandler: 4,
    General: 5, //1341 // QA
    All: 6 //1342 // QA
}

export var assetTypeStrings = {
    ALL: "All",
    FURNACE: "Furnace",
    AC: "Air Conditioner",
    HEAT_PUMP: "Heat Pump",
    AIR_HANDLER: "Air Handler"
}

export var DwellwellAlertTypes = {
    BLOWER_FAILURE: '13',
    IGNITION_FAILURE: '42',
    INDUCTION_FAILURE: '44',
    SHUTDOWN_FAILURE: '43'
}

export var timeframeStrings = {
    twentyFourHrs: "Last 24 Hours",
    sevenDays: "Last 7 Days",
    thirtyDays: "Last 30 Days"
}

export var timeframeKeys = {
    twentyFourHrs: "twentyFourHrs",
    sevenDays: "sevenDays",
    thirtyDays: "thirtyDays"
}

export var ColumnSortTypes = {
    ALPHABETICAL: "ALPHABETICAL",
    DATE: "DATE",
    NUMERIC: "NUMERIC"
}

export var Equipment = {
    FURNACE : "Furnace",
    AIR_CONDITIONER : "AirConditioner",
    AIR_HANDLER : "AirHandler",
    HEAT_PUMP : "HeatPump",
    BOILER : "Boiler",
    HOT_WATER_HEATER : "HotWaterHeater",
    THERMOSTAT : "Thermostat",
    OTHER: "Other"
}

export var GraphTypes = {
    ASSET: "ASSET",
    ALERT: "ALERT",
    TRIAGE_ALERTS: "TRIAGEALERTS",
    MULTISERIES: "MULTISERIES"
}

export var ViewTypes = {
    WholeRun: "WholeRun",
    Last150: "Last150",
    RawData: "RawData",
    MultiSeries: "MULTISERIES"
}

export var AxisTypes = {
    NONE: "NONE",
    TEMP: "TEMP",
    WIFI: "WIFI"
}

export var alertType  = {
    ALL: "All",
    CRITICAL: "Critical",
    WARNING: "Warning"
  
}

export var jsCreateCase = {
    firstName: "",
    lastName: "",
    organizationId: "",
    userID : "",
    comment: "",
}

export const jsNewPartner = {
    name: "",
    company: "",
    description: "",
    typeId: "",
    isBillable: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    phone: "",
    notificationEmailAddresses: [],
    secretKey: "",
    website: "",
    contractType: "",
    firstBillingDate: "",
    complementaryUnits: "",
    owner :""
};

export const workflowHeaders = [
    { label: "Partner", key: "partner" },
    { label: "Customer", key: "customer" },
    { label: "Homes", key: "homes" },
    { label: "System", key: "system" },
    { label: "AssetType", key: "assetType" },
    { label: "Asset", key: "asset" },
    { label: "Devices", key: "devices" },
    { label: "Status", key: "status" },
    { label: "State", key: "state" },
    { label: "Alert Partner Via Email", key: "alertPartnerViaEmail" },
    { label: "Provisioning_CTonWrongWire", key: "provisioning_CTonWrongWire" },
    { label: "Provisioning_CurrentDropOuts", key: "provisioning_CurrentDropOuts" },
    { label: "Provisioning_NoData", key: "provisioning_NoData" },
    { label: "Provisioning_SensorMappingIssue", key: "provisioning_SensorMappingIssue" },
    { label: "Provisioning_UnknownIssue", key: "provisioning_UnknownIssue" },
    { label: "Provisioning_AlertCreated", key: "provisioning_AlertCreated" }
];

export const COLORS = [
    '#0033a0', '#3ed3c2', '#ff7555', '#ff9900', '#7d8ee2',
    '#ff3c68', '#85a93f', '#ffda6c', '#f97306', '#c20078',
    '#ffb07c', '#cd7f32', '#847545', '#0f4d92', '#0bda51',
    '#00ff00', '#d891ef', '#9f8170', '#ff00cc', '#8a2be2',
    '#5f9ea0', '#8a2be2', '#00ff7f', '#9932cc', '#bdb76b',
    '#ff4500', '#da70d6', '#ffa500', '#cd5c5c', '#ffa07a',
    '#4682b4', '#8b4513', '#9acd32', '#ff8c00', '#ff1493',
    '#00ced1', '#4b0082', '#f08080', '#add8e6', '#90ee90',
    '#d3d3d3', '#ffb6c1', '#ffff00', '#00fa9a', '#ff00ff',
    '#1e90ff', '#ffa07a', '#00ff00', '#ff00ff', '#ff69b4',
    '#f0e68c', '#daa520', '#cd5c5c', '#48d1cc', '#9370db',
    '#ff7f50', '#4b0082', '#87cefa', '#32cd32', '#f4a460',
    '#db7093', '#000080', '#7fffd4', '#008080'
];

export const jsStateMap = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FL": "Florida",
    "GA": "Georgia",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PA": "Pennsylvania",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
};

export const ASSET_TYPE_OPTIONS = [
    { value: "AirConditioner", label: "Air Conditioner" },
    { value: "AirHandler",     label: "Air Handler" },
    { value: "Boiler",         label: "Boiler" },
    { value: "Furnace",        label: "Furnace" },
    { value: "HeatPump",       label: "Heat Pump" },
    { value: "WaterHeater",    label: "Water Heater" },
    { value: "Thermostat",     label: "Thermostat" },
];

export var boxLoader = "Loading...";

